// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2jiIW","bigColWidth":"Table_bigColWidth__3SkcJ","biggerColWidth":"Table_biggerColWidth__1PGir","row":"Table_row__3lFZX","col":"Table_col__1gxll"};